export const NATIVE_EMBED_PLUGIN_IS_RESIZING_KEY = 'nativeEmbedPlugin.isResizing';
export const NATIVE_EMBED_PLUGIN_RESIZING_WIDTH_KEY = 'nativeEmbedPlugin.resizing-width';
